import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export default function getResizedProfileImage(url = '', imageSize = '60x60'): string {
  let pathToImage = '';
  const extensions = ['jpg', 'png', 'jpeg', 'gif'];
  const isDefaultImage = url.includes('default_');

  const splittedUrl = url.split('.');
  const activeExtension = extensions.find((value) => splittedUrl[splittedUrl.length - 1].match(value));

  if (url.length === 0 || !activeExtension) {
    return url;
  }

  const sizePrefix = isDefaultImage ? '.' : '-';
  const dottedActiveExtension = `.${activeExtension}`;

  if (isDefaultImage || url.startsWith('http://') || url.startsWith('https://')) {
    pathToImage = url.replace(dottedActiveExtension, `${sizePrefix}${imageSize}${dottedActiveExtension}`);
  } else {
    pathToImage = url.replace(dottedActiveExtension, `${BASE_URL}${sizePrefix}${imageSize}${dottedActiveExtension}`);
  }

  return pathToImage;
}
